(function () {
    'use strict';

    angular.module("imApp").factory("modelsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1167,
                    parameters: parms || {}
                });
            },
            listModels: function (parms) {
                return $ihttp.post({
                    method: 1160,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
